module.exports = __webpack_public_path__ + "static/media/0.11a02470.svg";